module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row activities"
  }, _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [_c('a', {
      attrs: {
        "href": item.target,
        "target": "_self"
      }
    }, [_c('div', {
      staticClass: "activity"
    }, [_c('div', {
      staticClass: "image-wrap"
    }, [_c('img', {
      attrs: {
        "src": item.imageUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text-wrap"
    }, [_c('p', [_vm._v(_vm._s(item.description))])])])])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEmptyList),
      expression: "isEmptyList"
    }]
  }, [_c('p', [_vm._v(_vm._s(_vm.emptyListTip))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f7893fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/nvui/activities/Activities.vue
// module id = 148
// module chunks = 1